module.exports = __webpack_public_path__ + "img/arrow.fb8f7388.svg";